export enum PointsCalculationType {
    BET = 'total_bet',
    WIN = 'win',
    MIXED = 'winxbet',
}